import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { DocumentsPAC } from '@shared/model';
import { DateUtilities } from "@mynexus/mynexus-ui-lib";
import { debounce } from "lodash-es";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AuthRequestPacCommercialStateManagerService } from "@pages/auth-request-pac-commercial/services";

@Component({
    selector: 'documents-tab-pac',
    templateUrl: './documents-tab-pac.component.html',
    styleUrls: ['./documents-tab-pac.component.scss'],
    standalone: false
})
export class DocumentsTabPacComponent implements OnInit {
  @Input() authRequestReceivedDate!: string;
  @Input() documents: DocumentsPAC[];
  @Input() isPacCommercial: boolean;

  @Output() backStep = new EventEmitter<void>();
  @Output() cancelProcess = new EventEmitter<void>();
  @Output() submitStep = new EventEmitter<DocumentsPAC[]>();
  @Output() updateDocuments = new EventEmitter<DocumentsPAC[]>();
  @Output() hasPreviousCarrierDocumentsEmitter = new EventEmitter<boolean>();

  private readonly requestStateManager = inject(AuthRequestPacCommercialStateManagerService);
  private readonly destroyRef = inject(DestroyRef);

  hasClinicalDocuments =  false;
  hasPreviousCarrierDocuments: boolean;

  ngOnInit(): void {
    this.documents = this.documents ?? [];
    this.hasClinicalDocuments = this.documents.length !== 0;
    this.updateDocuments.emit(this.documents);

    this.requestStateManager.stateChanges()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(state => {
      this.hasPreviousCarrierDocuments = state?.authDetails?.hasPreviousCarrierDocuments ?? false;
    });
  }

  onClickBack(): void {
    this.backStep.emit();
  }

  onCancel(): void {
    this.cancelProcess.emit();
  }

  onSubmit(): void {
    this.submitDebounced();
  }

  private submitDebounced = debounce(() => {
    this.submitStep.emit(this.documents);
  }, 500);

  loadFiles(uploadedFiles: DocumentsPAC[]) {
    this.documents = uploadedFiles.length ? this.applyAuthDate(uploadedFiles) : null;

    this.updateDocuments.emit(this.documents);
  }

  onChangeHasClinicalDocumentsField(): void {
    if (!this.hasClinicalDocuments) {
      this.documents = [];
      this.updateDocuments.emit([]);
      this.hasPreviousCarrierDocumentsEmitter.emit(false);
    }
  }

  onChangeHasPreviousCarrierAuthorizationDocuments(): void {
    this.hasPreviousCarrierDocumentsEmitter.emit(this.hasPreviousCarrierDocuments);
  }

  private applyAuthDate(documents: DocumentsPAC[]): DocumentsPAC[] {
    return documents.map(document => {
      return {
        ...document,
        dateTimeFaxReceived: this.authRequestReceivedDate != null && DateUtilities.isDateValid(this.authRequestReceivedDate)
          ? this.authRequestReceivedDate : document.dateTimeFaxReceived
      };
    });
  }
}
